import type { ShadingSystemCatalogItem } from "../model/types";

export const dedupeShadingCatalogForPoolDisplay = (
  items: ShadingSystemCatalogItem[],
  headers: { dataKey: string }[]
): ShadingSystemCatalogItem[] => {
  if (!headers?.length) return items;
  const uniqueItems = new Map<string, ShadingSystemCatalogItem>();

  items.forEach((item) => {
    const key = headers?.map((header) => item[header.dataKey as keyof ShadingSystemCatalogItem])?.join("\0");
    if (!uniqueItems.has(key)) uniqueItems.set(key, item);
  });

  return [...uniqueItems.values()];
};
